import { render, staticRenderFns } from "./PeopleList.vue?vue&type=template&id=5654f063"
import script from "./PeopleList.ts?vue&type=script&lang=ts&external"
export * from "./PeopleList.ts?vue&type=script&lang=ts&external"
import style0 from "./PeopleList.vue?vue&type=style&index=0&id=5654f063&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports